import { Button, ButtonProps, Typography } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { css, cx } from '@emotion/css';
import React from 'react';
import { isString } from 'lodash-es';

interface MenuButtonProps extends ButtonProps {
  active?: boolean;
  label: string | React.ReactNode;
  hoverHighlight?: boolean;
  customIcon?: React.ReactNode;
}

const checkCss = css`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  color: var(--ant-primary-color);
`;

export const MenuButton = (props: MenuButtonProps) => {
  const { label, active = false, hoverHighlight = true, customIcon, onClick } = props;

  return (
    <Button
      className={cx(
        '!pl-2 !pr-6 !text-content-400 !w-full !text-left',
        hoverHighlight ? 'hover:!bg-fill-200' : undefined,
      )}
      type="link"
      icon={customIcon}
      onClick={onClick}
    >
      {isString(label) ? (
        <Typography.Text ellipsis title={label}>
          {label}
        </Typography.Text>
      ) : (
        label
      )}
      {active && <CheckOutlined className={checkCss} />}
    </Button>
  );
};
